import { Contract, MyProfileData, ContractDetails as TContractDetails } from 'cpfr-common';
import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContractsOverview } from '../contracts-overview';

export const ContractsUi: React.FC<{
    contracts?: Array<Contract & TContractDetails>;
    isContactInformationChangePending: boolean;
    isContractEndOptionChangePending: boolean;
    myProfile?: MyProfileData;
}> = ({ contracts, isContactInformationChangePending, isContractEndOptionChangePending, myProfile }) => {
    const { t } = useTranslation('contracts');
    if (!contracts) {
        return null;
    }

    if (!contracts.length) {
        return (
            <Notification status={NotificationStatus.error} title={t('error.headline')} visible showCloseButton={false}>
                {t('error.text')}
            </Notification>
        );
    }

    return (
        <>
            <ContractsOverview
                contracts={contracts}
                isContactInformationChangePending={isContactInformationChangePending}
                myProfile={myProfile}
                isContractEndOptionChangePending={isContractEndOptionChangePending}
            />
        </>
    );
};
